import type {
  DigiQuoteThumbnailImageQueryKey,
  UseDigiQuoteThumbnailImageParams,
} from '../types';

export const getDigiQuoteThumbnailImageQueryKey = (
  params: UseDigiQuoteThumbnailImageParams,
): DigiQuoteThumbnailImageQueryKey => [
  'quotes',
  'quoteItems',
  'digiQuoteThumbnailImage',
  params,
];
